<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
  <circle cx="8.5" cy="8.5" r="6.5" stroke="#E5E5E5" stroke-width="1.4"/>
  <path d="M3 6.5C4.8 5.2 12.2 5.2 14 6.5" stroke="#E5E5E5" stroke-width="1.1" stroke-linecap="round"/>
  <path d="M2 8.5C4.2 7.2 12.8 7.2 15 8.5" stroke="#E5E5E5" stroke-width="1.1" stroke-linecap="round"/>
  <path d="M3 10.5C4.8 11.8 12.2 11.8 14 10.5" stroke="#E5E5E5" stroke-width="1.1" stroke-linecap="round"/>
</svg>
